<template>
  <AdaptiveSheet
    full-screen
    class="authLoginScreen countryPickerPopup"
    :opened="isOpen"
    :close-by-backdrop-click="false"
    :close-by-outside-click="false"
    tablet-fullscreen
    :close-on-escape="false"
    close-on-select
    swipe-to-close
    :backdrop="true"
    style="min-height: 100%; --f7-popup-bg-color: #fff; --f7-popup-z-index: 21000; --f7-sheet-bg-color: #fff; --f7-sheet-z-index: 21000;"
    @close="onPopupClose"
  >
    <f7-view>
      <f7-page>
        <f7-navbar>
          <f7-nav-title>{{ options.title }}</f7-nav-title>
          <f7-nav-right>
            <f7-link @click="close">{{ options.closeLabel }}</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div class="country-picker-searchbar">
          <input sylte="border-raidius:25px"
            v-model="query"
            type="search"
            class="country-picker-search-input"
            autocomplete="off"
            :placeholder="options.searchPlaceholder"
            :aria-label="options.searchPlaceholder"
          />
        </div>
        <div class="page-content">
          <ul class="iti__country-list country-picker-list">
            <li
              v-for="row in filteredRows"
              :key="row.iso2"
              class="iti__country item-content"
              :data-dial-code="row.dialCode"
              :data-iso2="row.iso2"
              v-html="row.html"
              @click="onChoose(row.iso2)"
            ></li>
          </ul>
          <div v-if="filteredRows.length === 0" class="country-picker-empty">
            {{ options.noResultsLabel }}
          </div>
        </div>
      </f7-page>
    </f7-view>
  </AdaptiveSheet>
</template>

<style scoped>
.country-picker-searchbar {
  flex-shrink: 0;
  padding: 8px 16px;
  background: var(--f7-page-bg-color, #fff);
}

.country-picker-searchbar .country-picker-search-input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid var(--f7-page-master-border-color, rgba(0, 0, 0, 0.1));
  border-radius: 18px;
  font-size: 15px;
  font-family: var(--f7-font-family);
  color: var(--f7-text-color, #000);
  background: var(--f7-list-item-background-color, #fff);
}

.country-picker-list {
  margin: 0;
  max-height: none;
}

.country-picker-list .iti__country {
  padding-left: 16px;
  padding-right: 16px;
}

.country-picker-empty {
  padding: 24px 16px;
  text-align: center;
  color: var(--f7-list-item-subtitle-text-color, rgba(0, 0, 0, 0.55));
  font-size: 14px;
}
</style>

<script setup>
import { computed, ref, watch } from "vue";
import AdaptiveSheet from "./common/AdaptiveSheet.vue";
import { useCountryPicker } from "@/js/composables/useCountryPicker.js";

const { isOpen, options, choose, close } = useCountryPicker();

const query = ref("");

const filteredRows = computed(() => {
  const q = query.value.trim().toLowerCase();
  if (!q) return options.value.rows;
  return options.value.rows.filter((row) =>
    (row.name || "").toLowerCase().includes(q)
  );
});

watch(isOpen, (open) => {
  if (!open) query.value = "";
});

function onChoose(iso2) {
  choose(iso2);
  query.value = "";
}

function onPopupClose() {
  close();
}
</script>